import { Q2Game } from "../../net/proto/q2_game";
import Utility from "../../../../utility/utility";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import Q2TableResultDetailCardsPattern from "./q2_table_result_detail_cards_pattern";
import Q2TableResultDetailScoreChangePattern from "./q2_table_result_detail_score_change_pattern";
import UserDataManager from "../../../../manager/user_manager";
import { IUserData } from "../../../public/model_data";
import ComponentBase from "../../../public/component/component_base";


const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/q2/Q2TableResultDetailItem')
export default class Q2TableResultDetailItem extends ComponentBase {

    @property(cc.Node)
    nodeRoot: cc.Node = null

    @property(cc.Sprite)
    spriteNo: cc.Sprite = null

    @property(cc.Label)
    labelName: cc.Label = null

    @property(cc.Label)
    labelScore: cc.Label = null

    @property(SpriteFrameHolder)
    spriteHodlerNo: SpriteFrameHolder = null
    
    @property(Q2TableResultDetailCardsPattern)
    chengPaiPattern: Q2TableResultDetailCardsPattern = null

    @property(Q2TableResultDetailCardsPattern)
    handcardsPattern: Q2TableResultDetailCardsPattern = null

    @property(Q2TableResultDetailScoreChangePattern)
    changeScorePattern: Q2TableResultDetailScoreChangePattern = null

    show(show: boolean, data?: Q2Game.GameSettle.ISeatInfo, no?: number){
        this.nodeRoot.active = !!show
        if(show){
            if(data.scoreBalance > 0){
                this.labelScore.string = `+${data.scoreBalance}`
            }else{
                this.labelScore.string = `${data.scoreBalance}`
            }             
            this.fillChengPaiPattern(data.positiveCards || [], data.positiveCardsScore)
            this.fillHandcardsPattern(data.negativeCards || [], data.negativeCardsScore)
            this.fillChangeScorePattern(data.specialItems || [], data.specialItemsScore)
            this.fillNoSprite(no)
            this.fillPlayerInfo(data.playerId)
        }
    }

    protected fillPlayerInfo(uid: number){ 
        this.labelName.string = ''  
        this.getUserData(uid, (data : IUserData) => { 
            this.labelName.string = Utility.filterPlayerName(data.name)
        });
    }

    protected fillNoSprite(no: number){
        this.spriteNo.spriteFrame = this.spriteHodlerNo.getSpriteFrameByKey(no.toString())
    }

    protected fillChangeScorePattern(scoreDataList: Q2Game.IScore[], score: number){
        this.changeScorePattern.show(true, scoreDataList, score)
    }

    protected fillChengPaiPattern(codeList: number[], score: number){
        this.chengPaiPattern.show(true, codeList, score)
    }

    protected fillHandcardsPattern(codeList: number[], score: number){
        this.handcardsPattern.show(true, codeList, score)
    }

}
